import { ApiEndpoint } from '@/api/registry';
import { useSuspenseApiQuery } from '@/api/useApiQuery';
import { TenantPrimaryKeys } from '@/configs/tenants/types';
import type { GetEventsPrimaryKeysResponse } from '@/features/forecasts/forecasts.api.types';
import { ForecastEventType } from '@/features/forecasts/hooks/useOrderData';
import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import { useTenant } from '@/providers/TenantProvider';

interface Props {
  include_static_features?: boolean;
  limit?: number;
}

export function useCdpPrimaryKeys({ include_static_features = false, limit = 100 }: Props = {}) {
  const { tenantAlias } = useTenant();
  const { tenantApiFilters, tenantApiGrains } = useTenantConfiguration();
  const queryResult = useSuspenseApiQuery<GetEventsPrimaryKeysResponse>(tenantAlias, ApiEndpoint.PrimaryKeys, {
    body: {
      event: ForecastEventType.Orders,
      filters: tenantApiFilters,
      grain: tenantApiGrains,
      include_static_features,
      limit,
    },
  });

  const response = queryResult?.data;
  const records = (response?.data ?? []) as TenantPrimaryKeys[];
  const primaryKey = records[0];

  return { data: primaryKey };
}
